module.exports = __webpack_public_path__ + "img/pr-3.d9bcd3c1.png";